import { render, staticRenderFns } from "./PNToxicology.vue?vue&type=template&id=470afb7e"
import script from "./PNToxicology.vue?vue&type=script&lang=js"
export * from "./PNToxicology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports